/**
 * Recipe vocabularies shared by the database, the API contracts, importers and the UI
 * (PLAN.md §4). Stored as text; the UI translates the keys.
 */
export const SOURCE_TYPES = [
  'youtube',
  'instagram',
  'tiktok',
  'x',
  'facebook',
  'web',
  'text',
  'image',
  'notion',
  'manual',
] as const;
export type SourceType = (typeof SOURCE_TYPES)[number];

export const MEAL_TYPES = ['breakfast', 'lunch', 'dinner', 'snack', 'dessert'] as const;
export type MealType = (typeof MEAL_TYPES)[number];

export const DIETS = [
  'vegetarian',
  'vegan',
  'pescatarian',
  'gluten_free',
  'dairy_free',
  'high_protein',
  'low_carb',
] as const;
export type Diet = (typeof DIETS)[number];

export const RECIPE_LANGUAGES = ['de', 'en'] as const;
export type RecipeLanguage = (typeof RECIPE_LANGUAGES)[number];

/** Image variants written by the image store (webp). */
export const IMAGE_VARIANTS = { thumb: 400, full: 1200 } as const;
export type ImageVariant = keyof typeof IMAGE_VARIANTS;

/** Public URL of an image variant. */
export const mediaUrl = (imageId: string, variant: ImageVariant) =>
  `/media/${imageId}/${variant}.webp`;
